import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=ffbdd908&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbdd908",
  null
  
)

export default component.exports